module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', [(!_vm.disable) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um dirigente",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Oculta os dirigentes inativados ou mostra todos os dirigentes",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.inativosOcultados = !_vm.inativosOcultados
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.inativosOcultados ? 'Mostrar Inativos' : 'Somente Ativos'))])]), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        placement: 'right',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_insercao",
    attrs: {
      "title": '<h5>Inclusões: ' + _vm.inclDirTexto + '</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("  Houve a inserção de novo(s) dirigentes(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        placement: 'right',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_exclusao",
    attrs: {
      "title": '<h5>Exclusões: ' + _vm.excDirTexto + '</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("  Houve a exclusão de dirigentes(s)")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "tableDirigentes",
    attrs: {
      "how-empty": "",
      "stacked": "md",
      "id": "dirigentes-table",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "tbody-tr-class": _vm.inativosMostrarOcultar,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "ds_nome",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value) + "    "), _c('span', {
          staticStyle: {
            "color": "cornflowerblue"
          }
        }, [_vm._v(_vm._s(row.item.cargo.ds_descricao))])]
      }
    }, {
      key: "dt_inicio_mandato",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "dt_fim_mandato",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.disable) ? _c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Detalhar")])], 1) : _c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-offset-0 fa-lg"
        }, [(_vm.arr[0] == row.index || _vm.arr[1] == row.index || _vm.arr[2] == row.index || _vm.arr[3] == row.index || _vm.arr[4] == row.index || _vm.arr[5] == row.index || _vm.arr[6] == row.index || _vm.arr[7] == row.index || _vm.arr[8] == row.index) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              placement: 'left'
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
          }],
          staticClass: "fa fa-warning",
          staticStyle: {
            "position": "relative",
            "top": "8px",
            "margin-left": "2px",
            "color": "#fb2916"
          },
          attrs: {
            "title": '<h5>Clique em editar para ver as mudanças.</h5>'
          }
        }) : _vm._e()])], 1)]
      }
    }, {
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 'FORM'),
      expression: "state === 'FORM'"
    }],
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "name": "frmAddChief"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.disable
    }
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome do dirigente')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome') && _vm._.hasIn(_vm.texto, 'ds_nome')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_nome + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_nome),
      expression: "dirigentes.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:255'),
      expression: "'required|min:5|max:255'"
    }],
    ref: "Nome do dirigente",
    staticClass: "form-control",
    attrs: {
      "name": "Nome do dirigente",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.dirigentes.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome do dirigente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome do dirigente')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('active')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'bt_ativo') && _vm._.hasIn(_vm.texto, 'bt_ativo')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_ativo + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Status:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_ativo),
      expression: "dirigentes.bt_ativo",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "active"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.dirigentes.bt_ativo, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_ativo", _vm._n(1))
      }
    }
  }), _vm._v(" Ativo\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_ativo),
      expression: "dirigentes.bt_ativo",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "active"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.dirigentes.bt_ativo, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_ativo", _vm._n(0))
      }
    }
  }), _vm._v(" Inativo\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('active')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Status é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Estado civil')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Estado civil"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_estado_civil') && _vm._.hasIn(_vm.texto, 'ds_estado_civil')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_estado_civil + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Estado civil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_estado_civil),
      expression: "dirigentes.ds_estado_civil"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Estado civil",
    staticClass: "form-control",
    attrs: {
      "name": "Estado civil"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dirigentes, "ds_estado_civil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SOLTEIRO"
    }
  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CASADO"
    }
  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DIVORCIADO"
    }
  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIUVO"
    }
  }, [_vm._v("Viúvo(a)")])]), _vm._v(" "), (_vm.errors.first('Estado civil')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Estado Civil é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Data de nascimento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Data de nascimento"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_nascimento') && _vm._.hasIn(_vm.texto, 'dt_data_nascimento')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.dt_data_nascimento + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Data de nascimento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dt_data_nascimento),
      expression: "dt_data_nascimento"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'),
      expression: "'required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'"
    }],
    ref: "Data de nascimento",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Data de nascimento",
      "data-vv-as": "Data de nascimento",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.dt_data_nascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dt_data_nascimento = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Data de nascimento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data de nascimento')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Sexo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Sexo"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_gender') && _vm._.hasIn(_vm.texto, 'ds_gender')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_gender + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Gênero:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_gender),
      expression: "dirigentes.ds_gender"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Sexo",
    staticClass: "form-control",
    attrs: {
      "name": "Sexo",
      "disabled": _vm.bloqueioCampos === true
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dirigentes, "ds_gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "MASCULINO"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FEMININO"
    }
  }, [_vm._v("Feminino")])]), _vm._v(" "), (_vm.errors.first('Sexo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Sexo é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Profissão')
    },
    attrs: {
      "disabled": _vm.bloqueioCampos === true
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Profissão"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_profissao') && _vm._.hasIn(_vm.texto, 'ds_profissao')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_profissao + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Profissão:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_profissao),
      expression: "dirigentes.ds_profissao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:255'),
      expression: "'required|min:5|max:255'"
    }],
    ref: "Profissão",
    staticClass: "form-control",
    attrs: {
      "name": "Profissão",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dirigentes.ds_profissao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_profissao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Profissão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Profissão')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CPF')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "CPF"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cpf') && _vm._.hasIn(_vm.texto, 'ds_cpf')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_cpf + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    ref: "CPF",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.bloqueioCampos === true,
      "name": "CPF",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.dirigentes.ds_cpf),
      callback: function($$v) {
        _vm.$set(_vm.dirigentes, "ds_cpf", $$v)
      },
      expression: "dirigentes.ds_cpf"
    }
  }), _vm._v(" "), (_vm.errors.first('CPF')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CPF do Dirigente é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nacionalidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nacionalidade"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nacionalidade') && _vm._.hasIn(_vm.texto, 'ds_nacionalidade')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_nacionalidade + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Nacionalidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_nacionalidade),
      expression: "dirigentes.ds_nacionalidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:255'),
      expression: "'required|min:5|max:255'"
    }],
    ref: "Nacionalidade",
    staticClass: "form-control",
    attrs: {
      "name": "Nacionalidade",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.dirigentes.ds_nacionalidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_nacionalidade", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nacionalidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nacionalidade')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('RG')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "RG"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_rg') && _vm._.hasIn(_vm.texto, 'ds_rg')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_rg + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                RG:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_rg),
      expression: "dirigentes.ds_rg"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5||max:20'),
      expression: "'required|min:5||max:20'"
    }],
    ref: "RG",
    staticClass: "form-control",
    attrs: {
      "name": "RG",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.dirigentes.ds_rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_rg", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('RG')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('RG')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.has('UF')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "placeOfBirth"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_naturalidade') && _vm._.hasIn(_vm.texto, 'ds_naturalidade')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_naturalidade + '</h5>'
    }
  }) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_uf') && _vm._.hasIn(_vm.texto, 'ds_uf')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_uf + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n\n                Naturalidade / UF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 junto"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_naturalidade),
      expression: "dirigentes.ds_naturalidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:255'),
      expression: "'min:3|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Naturalidade",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.dirigentes.ds_naturalidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_naturalidade", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Naturalidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Naturalidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_uf),
      expression: "dirigentes.ds_uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "UF",
    staticClass: "form-control",
    attrs: {
      "name": "UF",
      "disabled": _vm.bloqueioCampos === true
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dirigentes, "ds_uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.estados), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errors.has('UF')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.has('UF do RG')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "rgOrgaoEmissor"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_orgao_emissor') && _vm._.hasIn(_vm.texto, 'ds_orgao_emissor')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_orgao_emissor + '</h5>'
    }
  }) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_rg_uf') && _vm._.hasIn(_vm.texto, 'ds_rg_uf')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_rg_uf + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n\n                Org. Emissor / UF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 junto"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_orgao_emissor),
      expression: "dirigentes.ds_orgao_emissor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:2|max:20'),
      expression: "'min:2|max:20'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "emissor",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.dirigentes.ds_orgao_emissor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_orgao_emissor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_rg_uf),
      expression: "dirigentes.ds_rg_uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "UF do RG",
    staticClass: "form-control",
    attrs: {
      "name": "UF do RG",
      "disabled": _vm.bloqueioCampos === true
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dirigentes, "ds_rg_uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.estados), function(uf) {
    return _c('option', {
      domProps: {
        "value": uf
      }
    }, [_vm._v(_vm._s(uf))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errors.has('UF do RG')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF do RG')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })]), _vm._v(" "), _c('fieldset', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cep')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cep"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_cep') && _vm._.hasIn(_vm.texto, 'endereco.ds_cep')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_cep + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                CEP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:9'),
      expression: "'required|max:9'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "type": "text",
      "mask": "#####-###"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.buscaCEP($event)
      }
    },
    model: {
      value: (_vm.dirigentes.endereco.ds_cep),
      callback: function($$v) {
        _vm.$set(_vm.dirigentes.endereco, "ds_cep", $$v)
      },
      expression: "dirigentes.endereco.ds_cep"
    }
  }), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CEP é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Cidade"
    }
  }, [_vm._v("\n                Cidade / UF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dirigentes.endereco.ds_cidade || _vm.dirigentes.endereco.ds_estado),
      expression: "dirigentes.endereco.ds_cidade || dirigentes.endereco.ds_estado"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "innerHTML": _vm._s((_vm.dirigentes.endereco.ds_cidade || '') + ' / ' + (_vm.dirigentes.endereco.ds_estado || ''))
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Endereço')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Endereço"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_rua') && _vm._.hasIn(_vm.texto, 'endereco.ds_rua')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_rua + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Endereço:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.endereco.ds_rua),
      expression: "dirigentes.endereco.ds_rua"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:60'),
      expression: "'required|min:5|max:60'"
    }],
    ref: "Endereço",
    staticClass: "form-control",
    attrs: {
      "name": "Endereço",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dirigentes.endereco.ds_rua)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes.endereco, "ds_rua", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Endereço')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Número')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Número"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_numero') && _vm._.hasIn(_vm.texto, 'endereco.ds_numero')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_numero + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Número:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.endereco.ds_numero),
      expression: "dirigentes.endereco.ds_numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:7'),
      expression: "'required|min:1|max:7'"
    }],
    ref: "Número",
    staticClass: "form-control",
    attrs: {
      "name": "Número",
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dirigentes.endereco.ds_numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes.endereco, "ds_numero", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Número')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Número')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Complemento"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_complemento') && _vm._.hasIn(_vm.texto, 'endereco.ds_complemento')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_complemento + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Complemento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.endereco.ds_complemento),
      expression: "dirigentes.endereco.ds_complemento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Complemento",
      "maxlength": "20",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dirigentes.endereco.ds_complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes.endereco, "ds_complemento", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Complemento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Complemento')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Bairro"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'endereco.ds_bairro') && _vm._.hasIn(_vm.texto, 'endereco.ds_bairro')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.endereco.ds_bairro + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Bairro:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.endereco.ds_bairro),
      expression: "dirigentes.endereco.ds_bairro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:32'),
      expression: "'max:32'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Bairro",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dirigentes.endereco.ds_bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes.endereco, "ds_bairro", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Bairro')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Bairro')))]) : _vm._e()])])])])]), _vm._v(" "), _c('fieldset', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Telefone"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_telefone') && _vm._.hasIn(_vm.texto, 'contato.ds_telefone')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.contato.ds_telefone + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.dirigentes.contato.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.dirigentes.contato, "ds_telefone", $$v)
      },
      expression: "dirigentes.contato.ds_telefone"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Celular"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_celular') && _vm._.hasIn(_vm.texto, 'contato.ds_celular')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.contato.ds_celular + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Celular",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.dirigentes.contato.ds_celular),
      callback: function($$v) {
        _vm.$set(_vm.dirigentes.contato, "ds_celular", $$v)
      },
      expression: "dirigentes.contato.ds_celular"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Fax"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'contato.ds_fax') && _vm._.hasIn(_vm.texto, 'contato.ds_fax')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.contato.ds_fax + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Fax:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "fax",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.dirigentes.contato.ds_fax),
      callback: function($$v) {
        _vm.$set(_vm.dirigentes.contato, "ds_fax", $$v)
      },
      expression: "dirigentes.contato.ds_fax"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('email do dirigente')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email do dirigente"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_email') && _vm._.hasIn(_vm.texto, 'ds_email')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_email + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.ds_email),
      expression: "dirigentes.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email do dirigente",
      "data-vv-as": "E-mail",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dirigentes.ds_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dirigentes, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('email do dirigente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do dirigente')))]) : _vm._e()])])])])]), _vm._v(" "), _c('fieldset', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Data Inicial')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Data Inicial"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'dt_inicio_mandato') && _vm._.hasIn(_vm.texto, 'dt_inicio_mandato')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + (_vm.texto.dt_inicio_mandato | _vm.moment('L')) + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Data Inicial:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dt_inicio_mandato),
      expression: "dt_inicio_mandato"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'),
      expression: "'required|validdate|dateeqpast|date_format:dd/MM/yyyy|after:01/01/1900'"
    }],
    ref: "Data Inicial",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Data Inicial",
      "name": "Data Inicial",
      "data-vv-as": "Data Inicial",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.dt_inicio_mandato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dt_inicio_mandato = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Data Inicial')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data Inicial')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Data Final')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Data Final"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'dt_fim_mandato') && _vm._.hasIn(_vm.texto, 'dt_fim_mandato')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + (_vm.texto.dt_fim_mandato | _vm.moment('L')) + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Data Final:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dt_fim_mandato),
      expression: "dt_fim_mandato"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|date_format:dd/MM/yyyy|after:Data Inicial'),
      expression: "'required|validdate|date_format:dd/MM/yyyy|after:Data Inicial'"
    }],
    ref: "Data Final",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Data Final",
      "name": "Data Final",
      "data-vv-as": "Data Final",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.dt_fim_mandato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dt_fim_mandato = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Data Final')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Data Final')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('positionMandate')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "positionMandate"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'cargo') && _vm._.hasIn(_vm.texto, 'cargo')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.cargo.ds_descricao + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Cargo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigentes.cargo),
      expression: "dirigentes.cargo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "positionMandate",
    staticClass: "form-control",
    attrs: {
      "name": "positionMandate"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dirigentes, "cargo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.mandatos), function(mandato) {
    return _c('option', {
      domProps: {
        "value": mandato
      }
    }, [_vm._v(_vm._s(mandato.ds_codigo + ' - ' + mandato.ds_descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('positionMandate')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Cargo é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v(" * Se o cargo for '12 - Designado(a)', incluir "), _c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/modelo_termo_de_designacao.docx'
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Termo de Designação")]), _vm._v(" nos Anexos do Dirigente/Designado")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Assina pela entidade?')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Assina pela entidade?"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'bt_assinatura_entidade') && _vm._.hasIn(_vm.texto, 'bt_assinatura_entidade')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_assinatura_entidade + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Assina pela entidade?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_assinatura_entidade),
      expression: "dirigentes.bt_assinatura_entidade",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "Assina pela entidade?"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.dirigentes.bt_assinatura_entidade, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_assinatura_entidade", _vm._n(1))
      }
    }
  }), _vm._v(" Sim\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_assinatura_entidade),
      expression: "dirigentes.bt_assinatura_entidade",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "Assina pela entidade?"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.dirigentes.bt_assinatura_entidade, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_assinatura_entidade", _vm._n(0))
      }
    }
  }), _vm._v(" Não\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('Assina pela entidade?')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Assina pela entidade é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Assinatura é obrigatória?')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Assinatura é obrigatória?"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'bt_assinatura_requerida') && _vm._.hasIn(_vm.texto, 'bt_assinatura_requerida')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_assinatura_requerida + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                Assinatura é obrigatória?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_assinatura_requerida),
      expression: "dirigentes.bt_assinatura_requerida",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "Assinatura é obrigatória?"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.dirigentes.bt_assinatura_requerida, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_assinatura_requerida", _vm._n(1))
      }
    }
  }), _vm._v(" Sim\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_assinatura_requerida),
      expression: "dirigentes.bt_assinatura_requerida",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "Assinatura é obrigatória?"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.dirigentes.bt_assinatura_requerida, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_assinatura_requerida", _vm._n(0))
      }
    }
  }), _vm._v(" Não\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('Assinatura é obrigatória?')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Assinatura é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('É representante legal?')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "É representante legal?"
    }
  }, [(_vm._.hasIn(_vm.mudancas, 'bt_representante_legal') && _vm._.hasIn(_vm.texto, 'bt_representante_legal')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao",
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.bt_representante_legal + '</h5>'
    }
  }) : _vm._e(), _vm._v("\n                É representante legal?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_representante_legal),
      expression: "dirigentes.bt_representante_legal",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "É representante legal?"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.dirigentes.bt_representante_legal, _vm._n(1))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_representante_legal", _vm._n(1))
      }
    }
  }), _vm._v(" Sim\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dirigentes.bt_representante_legal),
      expression: "dirigentes.bt_representante_legal",
      modifiers: {
        "number": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "É representante legal?"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.dirigentes.bt_representante_legal, _vm._n(0))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.dirigentes, "bt_representante_legal", _vm._n(0))
      }
    }
  }), _vm._v(" Não\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('É representante legal?')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Representante legal é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), (!_vm._.includes([12, 13], _vm._.get(_vm.dirigentes, 'cargo.ds_codigo', 0))) ? _c('fieldset', {
    attrs: {
      "id": "cadastroEmpresasLigadasDirigentes"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("\n              Adicione abaixo participação em empresa a qual faça parte. Se nenhuma empresa for adicionada será considerado que não está ligado a nenhuma empresa exceto "), _c('i', [_vm._v(_vm._s(_vm.entidadeParceira.ds_nome))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px",
      "text-align": "center"
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "text-align": "center"
    }
  }, [_vm._v("Data Desligamento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.adicionaEmpresaLigada(_vm.dirigentes)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adiciona empresa")])])])]), _vm._v(" "), _c('tbody', [((_vm._.get(_vm.dirigentes, 'dados.empresas', [])).length === 0) ? [_vm._m(5)] : _vm._l((_vm._.get(_vm.dirigentes, 'dados.empresas', [])), function(empresa, idxEmpresa) {
    return _c('tr', [(_vm._.isNull(empresa.inclusao)) ? [_c('td', [_c('div', {
      staticClass: "required-field",
      class: {
        'has-error': _vm.errors.first('CNPJ_' + idxEmpresa)
      }
    }, [_c('the-mask', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|min:14|max:14|cnpj'),
        expression: "'required|min:14|max:14|cnpj'"
      }],
      staticClass: "form-control",
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "name": 'CNPJ_' + idxEmpresa,
        "type": "text",
        "mask": "NN.NNN.NNN/NNNN-##",
        "tokens": _vm.$cnpjTokens
      },
      model: {
        value: (empresa.cnpj),
        callback: function($$v) {
          _vm.$set(empresa, "cnpj", $$v)
        },
        expression: "empresa.cnpj"
      }
    }), _vm._v(" "), (_vm.errors.first('CNPJ_' + idxEmpresa)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ_' + idxEmpresa)))]) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "required-field",
      class: {
        'has-error': _vm.errors.first('razao_social_empresa_' + idxEmpresa)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (empresa.nome),
        expression: "empresa.nome"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": 'razao_social_empresa_' + idxEmpresa,
        "maxlength": "500"
      },
      domProps: {
        "value": (empresa.nome)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(empresa, "nome", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.first('razao_social_empresa_' + idxEmpresa)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(" Razão Social da empresa é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-group"
    }, [_c('datepicker', {
      ref: "data_desligamento",
      refInFor: true,
      attrs: {
        "name": "data_desligamento",
        "input-class": "form-control",
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "placeholder": "__ /__ /____",
        "format": "dd/MM/yyyy"
      },
      model: {
        value: (empresa.desligamento),
        callback: function($$v) {
          _vm.$set(empresa, "desligamento", $$v)
        },
        expression: "empresa.desligamento"
      }
    }), _vm._v(" "), (!_vm._.isNull(empresa.desligamento)) ? _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
      }],
      staticClass: "btn btn-default btn-flat",
      attrs: {
        "type": "button",
        "title": '<h5>Exclui data de desligamento</h5>'
      },
      on: {
        "click": function($event) {
          empresa.desligamento = null
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.dirigentes.dados.empresas.splice(idxEmpresa, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])])] : [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm._f("cnpj")(empresa.cnpj)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(empresa.nome))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(!_vm._.isNull(empresa.desligamento)) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm._f("moment")(empresa.desligamento, "L")) + "\n                    ")]) : _c('span', [_c('datepicker', {
      ref: "data_desligamento",
      refInFor: true,
      attrs: {
        "name": "data_desligamento",
        "input-class": "form-control",
        "language": _vm.$datePickerPtBR,
        "maxlength": "20",
        "placeholder": "__ /__ /____",
        "format": "dd/MM/yyyy"
      },
      model: {
        value: (empresa.desligamento),
        callback: function($$v) {
          _vm.$set(empresa, "desligamento", $$v)
        },
        expression: "empresa.desligamento"
      }
    }), _vm._v(" "), (!_vm._.isNull(empresa.desligamento)) ? _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
      }],
      staticClass: "btn btn-default btn-flat",
      attrs: {
        "type": "button",
        "title": '<h5>Exclui data de desligamento</h5>'
      },
      on: {
        "click": function($event) {
          empresa.desligamento = null
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bold",
        "color": "var(--cor-destaque)"
      }
    }, [_vm._v("Não pode ser excluído")])]], 2)
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_c('b', [_vm._v("  Anexos do Dirigente/Designado:")]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'documentos') && _vm._.hasIn(_vm.texto, 'documentos')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_alteracao"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.dirigentes.documentos,
      "documentTypes": '',
      "disable": '',
      "localUso": _vm.listaDocDirigentes,
      "salvouOK": _vm.salvouOK
    }
  })], 1)])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.frmAddChief)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar Dirigente")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onCancel(_vm.frmAddChief)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("  Dados pessoais:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("  Endereço:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("  Contato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("  Período do mandato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v(" Participação em Empresas:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Não esta ou esteve ligado a nenhuma empresa nos últimos 12 meses")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-018d88a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dirigentes.vue
// module id = 1848
// module chunks = 1